import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit} from '@fortawesome/free-solid-svg-icons'
export const EditButton = ({handleEditBtn, hadnleEditName, statusId, name, isoCode}) => {

  const handleShow = () => {
    hadnleEditName({statusId, name, isoCode})
    handleEditBtn(true)
  };

    return(
        <React.Fragment>
           <div className="custom-button">
            <FontAwesomeIcon className="edit-button-icon" icon={faEdit} onClick={() => handleShow()} ></FontAwesomeIcon>
           </div>
        </React.Fragment>
    )
}